import React, { createContext, useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import fileSize from 'filesize';
import { toast } from 'react-toastify';
import pdfMake from 'pdfmake';
import {
  Box,
  Button,
  Paper,
  Stack,
  Stepper,
  Step,
  StepLabel
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useHistory } from 'react-router-dom';
import Toast from '../../components/Toast';
import { Header } from '../../components/Header';
import { ModalLoading } from '../../components/ModalLoading';
import { RequesterData } from './components/RequesterData';
import { CollectData } from './components/CollectData';
import { LoadData } from './components/LoadData';
import { TaxInfo } from './components/TaxInfo';
import { SearchKnowledge } from './components/SearchKnowledge';
import { ModalWishImportInvoice } from './components/ModalWishImportInvoice';
import { ModalChangeRequesterData } from './components/ModalChangeRequesterData';
import { ModalSearchKnowledge } from './components/ModalSearchKnowledge';
import { ModalShowInvoiceSearchList } from './components/ModalShowInvoiceSearchList';
import { ModalChangeCollectAddress } from './components/ModalChangeCollectAddress';
import { ModalAddCollectAddress } from './components/ModalAddCollectAddress';
import { ModalAcceptTransportTerms } from './components/ModalAcceptTransportTerms';
import { ModalReceiveCollectInfo } from './components/ModalReceiveCollectInfo';
import { ModalCreateDeclaration } from './components/ModalCreateDeclaration';
import { ModalFinancialRestriction } from './components/ModalFinancialRestriction';
import { ModalRemoveDeclaration } from './components/ModalRemoveDeclaration';
import { ModalRemoveInvoice } from './components/ModalRemoveInvoice';
import { ModalRemoveFile } from './components/ModalRemoveFile';
import { ModalAcceptInvoiceNotIssued } from './components/ModalAcceptInvoiceNotIssued';
import { ModalAcceptResponsibilityTerms } from './components/ModalAcceptResponsibilityTerms';
import { ModalCollectCreated } from './components/ModalCollectCreated';
import { useAuth } from '../../hooks/Auth';
import { useApp } from '../../hooks/Global';
import { useIntegration } from '../../hooks/Integration';
import { useManager } from '../../hooks/Manager';
import { useWorkflow } from '../../hooks/Workflow';
import { useModal } from '../../hooks/Modal';
import { usePickup } from '../../hooks/Pickup';
import { useStorage } from '../../hooks/Storage';
import { parseCpfCnpj, parsePhone } from '../../helpers/parseValues';
import { options } from '../../helpers/toastOptions';
import { Container, Content, Route, TitlePage } from './styled';

import { contentDeclaration } from '../../reports/contentDeclaration';

const steps = [
  'Dados do Solicitante',
  'Pesquisar Conhecimento',
  'Dados da Coleta',
  'Dados da Carga',
  'Informações Fiscais'
];

export const ReverseCollectContext = createContext({});

const ReverseCollect = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const [transportTypeList, setTransportTypeList] = useState([]);
  const [transportSelectedToModal, setTransportSelectedToModal] = useState('');
  const [freightTypeList, setFreightTypeList] = useState([]);
  const [materialTypeList, setMaterialTypeList] = useState([]);
  const [otherMaterialId, setOtherMaterialId] = useState('');
  const [checkListSelected, setCheckListSelected] = useState({});
  const [statesList, setStatesList] = useState([]);
  const [requesterContact, setRequesterContact] = useState({
    contactName: '',
    contactEmail: '',
    phoneNumber: '',
    extension: ''
  });
  const [collectRequesterData, setCollectRequesterData] = useState({});
  const [clientInternalCode, setClientInternalCode] = useState('');
  const [dateSearchFrom, setDateSearchFrom] = useState('');
  const [dateSearchTo, setDateSearchTo] = useState('');
  const [knowledgeSearchNumber, setKnowledgeSearchNumber] = useState('');
  const [knowledgeSearchId, setKnowledgeSearchId] = useState('');
  const [invoiceSearchNumber, setInvoiceSearchNumber] = useState('');
  const [ufSearchFrom, setUfSearchFrom] = useState('');
  const [ufSearchTo, setUfSearchTo] = useState('');
  const [modalSearch, setModalSearch] = useState('');
  const [documentSearchSender, setDocumentSearchSender] = useState('');
  const [documentSearchRecipient, setDocumentSearchRecipient] = useState('');
  const [
    selectedKnowledgeIdToShowInvoices,
    setSelectedKnowledgeIdToShowInvoices
  ] = useState('');
  const [
    selectedKnowledgeNumberToShowInvoices,
    setSelectedKnowledgeNumberToShowInvoices
  ] = useState('');
  const [lastSearchPayload, setLastSearchPayload] = useState({});
  const [isSubmittingSearchPagination, setIsSubmittingSearchPagination] =
    useState(false);
  const [searchTotalPages, setSearchTotalPages] = useState(1);
  const [searchRows, setSearchRows] = useState([]);
  const [searchPage, setSearchPage] = useState(0);
  const [knowledgeNumber, setKnowledgeNumber] = useState('');
  const [knowledgeId, setKnowledgeId] = useState('');
  const [collectSenderData, setCollectSenderData] = useState({});
  const [disabledSenderData, setDisabledSenderData] = useState(false);
  const [addressSenderList, setAddressSenderList] = useState([]);
  const [selectedAddressSenderIndex, setSelectedAddressSenderIndex] =
    useState(0);
  const [collectRecipientData, setCollectRecipientData] = useState({});
  const [collectContactData, setCollectContactData] = useState([]);
  const [collectLoadData, setCollectLoadData] = useState({});
  const [collectLoadAvailabilityData, setCollectLoadAvailabilityData] =
    useState({});
  const [hasAcceptResponsibilityTerms, setHasAcceptResponsibilityTerms] =
    useState(false);
  const [addressList, setAddressList] = useState([]);
  const [selectedAddressIndex, setSelectedAddressIndex] = useState(0);
  const [showAlternativeContact, setShowAlternativeContact] = useState(false);
  const [receiveCollectInfoChecked, setReceiveCollectInfoChecked] = useState([
    false,
    false,
    true
  ]);
  const [receiveCollectInfoPhone, setReceiveCollectInfoPhone] = useState('');
  const [
    receiveCollectInfoPhoneConfirmation,
    setReceiveCollectInfoPhoneConfirmation
  ] = useState('');
  const [receiveCollectInfoEmail, setReceiveCollectInfoEmail] = useState('');
  const [
    receiveCollectInfoEmailConfirmation,
    setReceiveCollectInfoEmailConfirmation
  ] = useState('');
  const [documentType, setDocumentType] = useState('');
  const [fileAmount, setFileAmount] = useState('');
  const [declarationFiles, setDeclarationFiles] = useState([]);
  const [invoiceFiles, setInvoiceFiles] = useState([]);
  const [invoiceNumberErrorList, setInvoiceNumberErrorList] = useState([]);
  const [invoiceDateErrorList, setInvoiceDateErrorList] = useState([]);
  const [otherFiles, setOtherFiles] = useState([]);
  const [removeDeclaration, setRemoveDeclaration] = useState('');
  const [removeInvoice, setRemoveInvoice] = useState('');
  const [removeFile, setRemoveFile] = useState('');
  const [acceptedInvoiceNotIssued, setAcceptedInvoiceNotIssued] =
    useState(false);
  const [customerAcceptGuidelines, setCustomerAcceptGuidelines] =
    useState(false);
  const [protocolCollectCreated, setProtocolCollectCreated] = useState('');
  const [protocolCollectCanceled, setProtocolCollectCanceled] = useState('');
  const [hasCreatePickupWithInvoice, setHasCreatePickupWithInvoice] =
    useState(false);
  const [contactName, setContactName] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [contactRamal, setContactRamal] = useState('');
  const [alternativeContactName, setAlternativeContactName] = useState('');
  const [alternativeContactEmail, setAlternativeContactEmail] = useState('');
  const [alternativeContactPhone, setAlternativeContactPhone] = useState('');
  const [alternativeContactExtension, setAlternativeContactExtension] =
    useState('');
  const [alternativeContactName2, setAlternativeContactName2] = useState('');
  const [alternativeContactEmail2, setAlternativeContactEmail2] = useState('');
  const [alternativeContactPhone2, setAlternativeContactPhone2] = useState('');
  const [alternativeContactExtension2, setAlternativeContactExtension2] =
    useState('');
  const [alternativeContact, setAlternativeContact] = useState(false);
  const [alternativeContact2, setAlternativeContact2] = useState(false);
  const [alternativeSenderContactName, setAlternativeSenderContactName] =
    useState('');
  const [alternativeSenderContactEmail, setAlternativeSenderContactEmail] =
    useState('');
  const [alternativeSenderContactPhone, setAlternativeSenderContactPhone] =
    useState('');
  const [
    alternativeSenderContactExtension,
    setAlternativeSenderContactExtension
  ] = useState('');
  const [alternativeSenderContactName2, setAlternativeSenderContactName2] =
    useState('');
  const [alternativeSenderContactEmail2, setAlternativeSenderContactEmail2] =
    useState('');
  const [alternativeSenderContactPhone2, setAlternativeSenderContactPhone2] =
    useState('');
  const [
    alternativeSenderContactExtension2,
    setAlternativeSenderContactExtension2
  ] = useState('');
  const [alternativeSenderContact, setAlternativeSenderContact] =
    useState(false);
  const [alternativeSenderContact2, setAlternativeSenderContact2] =
    useState(false);
  const [disableSenderName, setDisableSenderName] = useState(false);
  const [disableSenderStreetAddress, setDisableSenderStreetAddress] =
    useState(true);
  const [disableSenderSuburb, setDisableSenderSuburb] = useState(true);
  const [isToValidateSenderDocument, setIsToValidateSenderDocument] =
    useState(true);
  const [isToValidateSenderAddressNumber, setIsToValidateSenderAddressNumber] =
    useState(true);
  const [dataToAddCollectAddressModal, setDataToAddCollectAddressModal] =
    useState({});
  const [enableDeclaration, setEnableDeclaration] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { user, token, signOut, userAddressList, userContactList } = useAuth();
  const { searchUser } = useApp();
  const { getBranchDetails } = useIntegration();
  const {
    getPickupManagerParameterization,
    GetAllTransportType,
    GetAllFreightType,
    GetAllMaterialType,
    GetStates
  } = useManager();
  const { getWorkflowManagerParameterization } = useWorkflow();
  const { openModal, openedModal, closeModal } = useModal();
  const {
    branchParameterizationId,
    createReversePickup,
    listUserLatestPickupAddress
  } = usePickup();
  const { uploadFile } = useStorage();
  const history = useHistory();

  const maxSM = useMediaQuery('(max-width:768px)');
  const maxMD = useMediaQuery('(max-width:900px)');

  const onSubmit = async () => {
    try {
      let newRequesterCollectContactData = [];

      collectContactData.forEach((collectContact) => {
        newRequesterCollectContactData.push(collectContact);
        collectSenderData.contactList.push(collectContact);
      });

      collectRequesterData.contactList.forEach((contact) => {
        newRequesterCollectContactData.push(contact);
      });

      newRequesterCollectContactData = newRequesterCollectContactData.filter(
        (value) =>
          value.name && value.email && String(value.phoneNumber).length >= 10
      );

      if (!documentType) {
        toast(
          <Toast
            title="Atenção!"
            type="error"
            content="Selecione um tipo de documento fiscal."
          />,
          options
        );
        return;
      }

      // eslint-disable-next-line no-use-before-define
      openLoadingModal();

      const request = {
        pickup: {
          pickupNotification: {
            hasWhatsapp: receiveCollectInfoChecked[0],
            hasEmail: receiveCollectInfoChecked[2],
            hasSms: receiveCollectInfoChecked[1],
            phoneNumber: parsePhone(receiveCollectInfoPhone),
            emailAddress: receiveCollectInfoEmail
          },
          requesterCorporation: {
            ...collectRequesterData,
            contactList: [...newRequesterCollectContactData]
          },
          shipmentList: []
        }
      };

      let taxInformationType;

      if (documentType === 'declaration') {
        taxInformationType = 'Declaração';
      } else if (documentType === 'invoiceIssued') {
        taxInformationType = 'Nota Fiscal';
      } else if (documentType === 'invoiceNotIssued') {
        taxInformationType = 'Nota Fiscal a Emitir';
      }

      const taxInformation = {
        taxInvoiceAware: true,
        taxInformationType,
        taxQuantity: fileAmount,
        taxDocumentList: [],
        taxInvoiceList: []
      };

      if (documentType === 'declaration') {
        // eslint-disable-next-line no-restricted-syntax
        for await (const declarationFile of declarationFiles) {
          const storageUrl = await uploadFile({
            file: declarationFile.file,
            token
          });

          taxInformation.taxDocumentList.push({
            isAwareAccepted: true,
            isDeclaration: true,
            taxDocumentTypeId: 3,
            storageUrl
          });
        }
      }

      if (documentType === 'invoiceIssued') {
        // eslint-disable-next-line no-restricted-syntax
        for await (const invoiceFile of invoiceFiles) {
          const invoice = {
            number: invoiceFile.invoiceNumber,
            storageUrl: await uploadFile({
              file: invoiceFile.file,
              token
            })
          };

          if (invoiceFile.invoiceDate) {
            invoice.dateIssue = invoiceFile.invoiceDate;
          }

          taxInformation.taxInvoiceList.push(invoice);
        }
      }

      // eslint-disable-next-line no-restricted-syntax
      for await (const otherFile of otherFiles) {
        taxInformation.taxDocumentList.push({
          isAwareAccepted: true,
          isDeclaration: otherFile.documentType === '3',
          documentType: otherFile.documentType,
          taxDocumentTypeId: otherFile.documentType,
          storageUrl: await uploadFile({ file: otherFile.file, token })
        });
      }

      const branchDetailsParams = {
        zip_code: collectSenderData.address.zipPostalCode,
        transport_type: String(collectLoadData.modal) === '2' ? 'A' : 'R',
        sender_document: collectSenderData?.document
      };

      if (collectRecipientData?.document) {
        branchDetailsParams.receiver_document = parseCpfCnpj(
          collectRecipientData?.document
        );
      }

      const branchList = await getBranchDetails({
        params: branchDetailsParams
      });

      if (branchList?.length > 0) {
        request.pickup.branchSenderId = branchList[0]?.idFilial;
        request.pickup.idRoute = branchList[0]?.idRota;
        request.pickup.routeDescription = branchList[0]?.descricaoRota;
        request.pickup.colRouteDescription = branchList[0]?.colRotaDescricao;
      }

      let typeTransportId = '';

      if (String(collectLoadData.modal) === '1') {
        typeTransportId = 9;
      }
      if (String(collectLoadData.modal) === '2') {
        typeTransportId = 8;
      }

      let branchParameterization;

      const pickupManagerResponse = await getPickupManagerParameterization({
        branchId: branchList[0]?.idFilial,
        transportTypeId: typeTransportId,
        pickupTypeId: 2,
        inputTypeId: 5,
        token
      });

      if (pickupManagerResponse?.length > 0) {
        branchParameterization =
          pickupManagerResponse[0]?.branchParameterizationId;
      }

      if (!branchParameterization) {
        const defaultPickupManagerResponse =
          await getPickupManagerParameterization({
            branchId: 1,
            transportTypeId: 9,
            pickupTypeId: 1,
            inputTypeId: 5
          });

        if (defaultPickupManagerResponse?.length > 0) {
          branchParameterization =
            defaultPickupManagerResponse[0]?.branchParameterizationId;
        }
      }

      request.pickup.branchParameterizationId = branchParameterization;

      const workflowManagerResponse = await getWorkflowManagerParameterization({
        branchId: branchList[0]?.idFilial,
        transportTypeId: typeTransportId,
        pickupTypeId: 2,
        inputTypeId: 5
      });

      if (workflowManagerResponse?.length > 0) {
        request.pickup.branchWorkflowParameterizationId =
          workflowManagerResponse[0]?.branchParameterizationId;
      }

      if (workflowManagerResponse === undefined) {
        const workflowManagerResponseDefault =
          await getWorkflowManagerParameterization({
            branchId: 1,
            transportTypeId: 9,
            pickupTypeId: 1,
            inputTypeId: 5
          });
        request.pickup.branchWorkflowParameterizationId =
          workflowManagerResponseDefault[0]?.branchParameterizationId;
      }

      const shipmentAvailability = {
        pickupFromDate: collectLoadAvailabilityData.pickupFromDate,
        pickupUntilDate: collectLoadAvailabilityData.pickupUntilDate
      };
      request.pickup.shipmentList.push({
        transportTypeId: collectLoadData.modal,
        freightTypeId: collectLoadData.freight,
        senderCorporation: collectSenderData,
        receiverCorporation: collectRequesterData,
        shipmentAvailability,
        shipmentPackageList: [
          {
            measureTypeId: 0,
            materialTypeId: '0', // collectLoadData.material,
            materialDetail: '', // collectLoadData.MaterialDetail,
            volumeQuantity: collectLoadData.loadVolume,
            length: '0', // collectLoadData.loadLength
            //   .replaceAll('.', '')
            //   .replace(',', '.'),
            width: '0', // collectLoadData.loadWidth
            //   .replaceAll('.', '')
            //   .replace(',', '.'),
            height: '0', // collectLoadData.loadHeight
            //   .replaceAll('.', '')
            //   .replace(',', '.'),
            weight: collectLoadData.loadWeight
              .replaceAll('.', '')
              .replace(',', '.')
          }
        ],
        taxInformation
      });

      if (knowledgeId) {
        request.pickup.knowledgeId = knowledgeId;
      }

      if (knowledgeNumber) {
        request.pickup.knowledgeNumber = knowledgeNumber;
      }

      if (clientInternalCode) {
        request.pickup.ClientInternalCode = clientInternalCode;
      }

      const protocol = await createReversePickup({ data: request, token });
      setProtocolCollectCreated(protocol);
      // eslint-disable-next-line no-use-before-define
      openCollectCreatedModal();
    } catch (error) {
      closeModal();
      // eslint-disable-next-line no-console
      console.log({ error });

      toast(
        <Toast
          title="Atenção!"
          content="Selecione um tipo de documento fiscal."
          type="error"
        />,
        options
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const openWishImportInvoiceModal = () => {
    openModal('modalWishImportInvoice');
  };

  const openChangeRequesterDataModal = () => {
    openModal('modalChangeRequesterData');
  };

  const openSearchKnowledgeModal = () => {
    openModal('modalSearchKnowledge');
  };

  const openShowInvoiceSearchListModal = () => {
    openModal('modalShowInvoiceSearchList');
  };

  const openChangeCollectAddressModal = () => {
    openModal('modalChangeCollectAddress');
  };

  const openAddCollectAddressModal = () => {
    openModal('modalAddCollectAddress');
  };

  const openAcceptTransportTermsModal = () => {
    openModal('modalAcceptTransportTerms');
  };

  const openReceiveCollectInfoModal = () => {
    openModal('modalReceiveCollectInfo');
  };

  const openCreateDeclarationModal = () => {
    openModal('modalCreateDeclaration');
  };

  const openRemoveDeclarationModal = (id) => {
    openModal('modalRemoveDeclaration');
    setRemoveDeclaration(id);
  };

  const openRemoveInvoiceModal = (id) => {
    openModal('modalRemoveInvoice');
    setRemoveInvoice(id);
  };

  const openRemoveFileModal = (id) => {
    openModal('modalRemoveFile');
    setRemoveFile(id);
  };

  const openAcceptInvoiceNotIssuedModal = () => {
    openModal('modalAcceptInvoiceNotIssued');
  };

  const openAcceptResponsibilityTermsModal = () => {
    openModal('modalAcceptResponsibilityTerms');
  };

  const openLoadingModal = () => {
    openModal('modalLoading');
  };

  const openCollectCreatedModal = () => {
    openModal('modalCollectCreated');
  };

  const createDeclarationPdf = ({
    senderData,
    recipientData,
    commodityList
  }) => {
    pdfMake
      .createPdf(
        contentDeclaration({ senderData, recipientData, commodityList })
      )
      .getBlob((blob) => {
        const id = uuid();

        const generatedDeclaration = new File([blob], `declaracao-${id}.pdf`, {
          type: blob.type
        });

        const newDeclarationFiles = [...declarationFiles];

        newDeclarationFiles.push({
          id,
          file: generatedDeclaration,
          name: generatedDeclaration.name,
          size: generatedDeclaration.size,
          readableSize: fileSize(generatedDeclaration.size),
          senderData,
          recipientData,
          commodityList
        });

        setDeclarationFiles(newDeclarationFiles);
      });
  };

  const handleShowAlternativeContact = () => {
    setShowAlternativeContact(!showAlternativeContact);
  };

  const handleSetAcceptInvoiceNotIssued = (event) => {
    setAcceptedInvoiceNotIssued(event.target.checked);
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleBackStep = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleNextStep = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const useForceUpdate = () => {
    const [value, setState] = useState(true);
    return () => setState(!value);
  };

  useEffect(async () => {
    if (!branchParameterizationId) {
      history.push('/acesso-rapido/tipo-de-coleta');
      return;
    }

    openLoadingModal();

    try {
      const data = userAddressList.map((userAddress) => {
        return {
          ...userAddress,
          document: parseCpfCnpj(user.document),
          name: user.name
        };
      });

      const searchAddressResponse = await searchUser({
        searchData: { name: user.name }
      });

      if (searchAddressResponse?.length > 0) {
        searchAddressResponse
          ?.filter((value) => String(value.document) !== String(user.document))
          .forEach((value) => {
            const {
              document,
              name,
              streetAddress,
              streetAddressNumber,
              addressComplement,
              telephone,
              email,
              contact,
              suburb,
              city,
              state,
              zipPostalCode
            } = value;

            const addressParsed = {
              additionalInformation: addressComplement
                ? addressComplement.toUpperCase()
                : '',
              city: city ? city.toUpperCase() : '',
              contactEmail: email ? email.toLowerCase() : '',
              contactExtension: '',
              contactName: contact ? contact.toUpperCase() : '',
              contactNumber: telephone
                ? String(parsePhone(telephone)).padStart(10, '0')
                : '',
              country: '',
              document,
              name: name ? name.toUpperCase() : '',
              state: state ? state.toUpperCase() : '',
              streetAddress: streetAddress ? streetAddress.toUpperCase() : '',
              streetAddressNumber: streetAddressNumber ?? '',
              suburb: suburb ? suburb.toUpperCase() : '',
              zipPostalCode: zipPostalCode ? parsePhone(zipPostalCode) : ''
            };

            data.push(addressParsed);
          });
      }

      setAddressList(data);

      const transportList = await GetAllTransportType(token);

      setTransportTypeList(transportList);

      const freightList = await GetAllFreightType(token);
      setFreightTypeList(freightList);

      const states = await GetStates(token);
      setStatesList(states);

      const latestPickupAddressList = await listUserLatestPickupAddress(token);

      if (latestPickupAddressList) {
        const { pickupContactList } = latestPickupAddressList;

        const contact = {};

        if (pickupContactList?.length > 0) {
          if (pickupContactList[0]?.contactName) {
            contact.contactName = pickupContactList[0]?.contactName;
          }
          if (pickupContactList[0]?.email) {
            contact.contactEmail = pickupContactList[0]?.email;
          }
          if (pickupContactList[0]?.phoneNumber) {
            contact.phoneNumber = String(
              pickupContactList[0]?.phoneNumber
            ).padStart(10, '0');
          }
          if (pickupContactList[0]?.extension) {
            contact.extension = pickupContactList[0]?.extension;
          }
        }

        setRequesterContact(contact);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    } finally {
      openWishImportInvoiceModal();
    }
  }, []);

  useEffect(() => {
    isSubmitting && onSubmit();
  }, [isSubmitting]);

  const contextValues = {
    steps,
    activeStep,
    handleBackStep,
    handleNextStep,
    requesterContact,
    collectRequesterData,
    setCollectRequesterData,
    addressList,
    setAddressList,
    selectedAddressIndex,
    setSelectedAddressIndex,
    clientInternalCode,
    setClientInternalCode,
    dateSearchFrom,
    setDateSearchFrom,
    dateSearchTo,
    setDateSearchTo,
    knowledgeSearchNumber,
    setKnowledgeSearchNumber,
    knowledgeSearchId,
    setKnowledgeSearchId,
    invoiceSearchNumber,
    setInvoiceSearchNumber,
    ufSearchFrom,
    setUfSearchFrom,
    ufSearchTo,
    setUfSearchTo,
    modalSearch,
    setModalSearch,
    documentSearchSender,
    setDocumentSearchSender,
    documentSearchRecipient,
    setDocumentSearchRecipient,
    selectedKnowledgeIdToShowInvoices,
    setSelectedKnowledgeIdToShowInvoices,
    selectedKnowledgeNumberToShowInvoices,
    setSelectedKnowledgeNumberToShowInvoices,
    lastSearchPayload,
    setLastSearchPayload,
    isSubmittingSearchPagination,
    setIsSubmittingSearchPagination,
    searchTotalPages,
    setSearchTotalPages,
    searchRows,
    setSearchRows,
    searchPage,
    setSearchPage,
    knowledgeNumber,
    setKnowledgeNumber,
    knowledgeId,
    setKnowledgeId,
    collectSenderData,
    setCollectSenderData,
    disabledSenderData,
    setDisabledSenderData,
    addressSenderList,
    setAddressSenderList,
    selectedAddressSenderIndex,
    setSelectedAddressSenderIndex,
    collectRecipientData,
    setCollectRecipientData,
    collectContactData,
    setCollectContactData,
    showAlternativeContact,
    handleShowAlternativeContact,
    customerAcceptGuidelines,
    hasAcceptResponsibilityTerms,
    setHasAcceptResponsibilityTerms,
    collectLoadData,
    setCollectLoadData,
    collectLoadAvailabilityData,
    setCollectLoadAvailabilityData,
    transportTypeList,
    setTransportTypeList,
    transportSelectedToModal,
    setTransportSelectedToModal,
    freightTypeList,
    materialTypeList,
    setMaterialTypeList,
    otherMaterialId,
    setOtherMaterialId,
    checkListSelected,
    setCheckListSelected,
    statesList,
    receiveCollectInfoChecked,
    setReceiveCollectInfoChecked,
    receiveCollectInfoPhone,
    setReceiveCollectInfoPhone,
    receiveCollectInfoPhoneConfirmation,
    setReceiveCollectInfoPhoneConfirmation,
    receiveCollectInfoEmail,
    setReceiveCollectInfoEmail,
    receiveCollectInfoEmailConfirmation,
    setReceiveCollectInfoEmailConfirmation,
    declarationFiles,
    setDeclarationFiles,
    createDeclarationPdf,
    fileAmount,
    setFileAmount,
    documentType,
    setDocumentType,
    invoiceFiles,
    setInvoiceFiles,
    invoiceNumberErrorList,
    setInvoiceNumberErrorList,
    invoiceDateErrorList,
    setInvoiceDateErrorList,
    otherFiles,
    setOtherFiles,
    removeDeclaration,
    setRemoveDeclaration,
    removeInvoice,
    setRemoveInvoice,
    removeFile,
    setRemoveFile,
    acceptedInvoiceNotIssued,
    setAcceptedInvoiceNotIssued,
    handleSetAcceptInvoiceNotIssued,
    openChangeRequesterDataModal,
    openSearchKnowledgeModal,
    openShowInvoiceSearchListModal,
    openChangeCollectAddressModal,
    openAddCollectAddressModal,
    openAcceptTransportTermsModal,
    openReceiveCollectInfoModal,
    openCreateDeclarationModal,
    openRemoveDeclarationModal,
    openRemoveInvoiceModal,
    openRemoveFileModal,
    openAcceptInvoiceNotIssuedModal,
    openAcceptResponsibilityTermsModal,
    openLoadingModal,
    protocolCollectCreated,
    protocolCollectCanceled,
    setProtocolCollectCanceled,
    hasCreatePickupWithInvoice,
    setHasCreatePickupWithInvoice,
    useForceUpdate,
    isSubmitting,
    setIsSubmitting,
    contactName,
    setContactName,
    contactEmail,
    setContactEmail,
    phoneNumber,
    setPhoneNumber,
    contactRamal,
    setContactRamal,
    alternativeContactName,
    setAlternativeContactName,
    alternativeContactEmail,
    setAlternativeContactEmail,
    alternativeContactPhone,
    setAlternativeContactPhone,
    alternativeContactExtension,
    setAlternativeContactExtension,
    alternativeContactName2,
    setAlternativeContactName2,
    alternativeContactEmail2,
    setAlternativeContactEmail2,
    alternativeContactPhone2,
    setAlternativeContactPhone2,
    alternativeContactExtension2,
    setAlternativeContactExtension2,
    alternativeContact,
    setAlternativeContact,
    alternativeContact2,
    setAlternativeContact2,
    alternativeSenderContactName,
    setAlternativeSenderContactName,
    alternativeSenderContactEmail,
    setAlternativeSenderContactEmail,
    alternativeSenderContactPhone,
    setAlternativeSenderContactPhone,
    alternativeSenderContactExtension,
    setAlternativeSenderContactExtension,
    alternativeSenderContactName2,
    setAlternativeSenderContactName2,
    alternativeSenderContactEmail2,
    setAlternativeSenderContactEmail2,
    alternativeSenderContactPhone2,
    setAlternativeSenderContactPhone2,
    alternativeSenderContactExtension2,
    setAlternativeSenderContactExtension2,
    alternativeSenderContact,
    setAlternativeSenderContact,
    alternativeSenderContact2,
    setAlternativeSenderContact2,
    disableSenderName,
    setDisableSenderName,
    disableSenderStreetAddress,
    setDisableSenderStreetAddress,
    disableSenderSuburb,
    setDisableSenderSuburb,
    isToValidateSenderDocument,
    setIsToValidateSenderDocument,
    isToValidateSenderAddressNumber,
    setIsToValidateSenderAddressNumber,
    dataToAddCollectAddressModal,
    setDataToAddCollectAddressModal,
    setCustomerAcceptGuidelines,
    enableDeclaration,
    setEnableDeclaration
  };

  return (
    <ReverseCollectContext.Provider value={contextValues}>
      <Container>
        {/* <Header /> */}
        <Content>
          <Box style={{ margin: '0 40px', paddingBottom: '40px' }}>
            {/* <Route>
              {!maxSM && (
                <>
                  Home {'>'} Acesso Rápido {'>'} Pedido de Coleta
                </>
              )}

              {!!user && (
                <Stack
                  direction="row"
                  spacing={2}
                  style={{
                    alignItems: 'center',
                    marginLeft: maxSM && 'auto'
                  }}
                >
                  <p>{user.name}</p>
                  <Button
                    type="button"
                    variant="contained"
                    color="secondary"
                    onClick={signOut}
                    size="small"
                  >
                    Sair
                  </Button>
                </Stack>
              )}
            </Route> */}

            <TitlePage>
              PEDIDO DE COLETA REVERSA
              <span style={{ marginTop: 15 }}>
                Visando otimizar a emissão dos conhecimentos de embarque
                pedimos, por gentileza, anexar os arquivos XML
                <br /> das notas fiscais transportadas pela Braspress, na
                solicitação de coleta ou encaminhe para o e-mail:
                <br />
                <a href={`mailto:${'ti.nfe@braspress.com'}`}>
                  ti.nfe@braspress.com
                </a>
              </span>
              <hr />
              <span>Preencha corretamente os campos abaixo</span>
            </TitlePage>

            <Paper elevation={2} style={{ marginTop: 16, padding: '16px' }}>
              <Stepper activeStep={activeStep}>
                {steps.map((label, index) => {
                  const stepProps = {};
                  const labelProps = {};

                  if (isStepSkipped(index)) {
                    stepProps.completed = false;
                  }

                  return (
                    <Step key={label} {...stepProps}>
                      {maxMD ? (
                        <StepLabel {...labelProps} />
                      ) : (
                        <StepLabel {...labelProps}>{label}</StepLabel>
                      )}
                    </Step>
                  );
                })}
              </Stepper>
            </Paper>

            {activeStep === 0 && <RequesterData />}
            {activeStep === 1 && <SearchKnowledge />}
            {activeStep === 2 && <CollectData />}
            {activeStep === 3 && <LoadData />}
            {activeStep === 4 && <TaxInfo />}
          </Box>
        </Content>
      </Container>

      {openedModal === 'modalWishImportInvoice' && <ModalWishImportInvoice />}
      {openedModal === 'modalChangeRequesterData' && (
        <ModalChangeRequesterData />
      )}
      {openedModal === 'modalSearchKnowledge' && <ModalSearchKnowledge />}
      {openedModal === 'modalShowInvoiceSearchList' && (
        <ModalShowInvoiceSearchList />
      )}
      {openedModal === 'modalChangeCollectAddress' && (
        <ModalChangeCollectAddress />
      )}
      {openedModal === 'modalAddCollectAddress' && <ModalAddCollectAddress />}
      {openedModal === 'modalAcceptTransportTerms' && (
        <ModalAcceptTransportTerms />
      )}
      {openedModal === 'modalReceiveCollectInfo' && <ModalReceiveCollectInfo />}
      {openedModal === 'modalCreateDeclaration' && <ModalCreateDeclaration />}
      {openedModal === 'modalRemoveDeclaration' && <ModalRemoveDeclaration />}
      {openedModal === 'modalRemoveInvoice' && <ModalRemoveInvoice />}
      {openedModal === 'modalRemoveFile' && <ModalRemoveFile />}
      {openedModal === 'modalAcceptInvoiceNotIssued' && (
        <ModalAcceptInvoiceNotIssued />
      )}
      {openedModal === 'modalAcceptResponsibilityTerms' && (
        <ModalAcceptResponsibilityTerms />
      )}
      {openedModal === 'modalLoading' && <ModalLoading />}
      {openedModal === 'modalCollectCreated' && <ModalCollectCreated />}
      {openedModal === 'modalFinancialRestriction' && (
        <ModalFinancialRestriction />
      )}
    </ReverseCollectContext.Provider>
  );
};

export default ReverseCollect;
